import { useT } from "../i18n";
import { Marke } from "./index";
import "../stile/kundenwahl.css";

/* ══════════════════════════════════════════════════════════════════
   Ein gesperrter Kunde sagt es — überall, wo er gewählt wird.

   AG-04 (Durchgang 03.10.2026, Nachprüfung Runde 4): Der erste Fix saß in
   `Kundenwahl.tsx`; die Angebotsmaske am Schreibtisch hat ihren eigenen
   Aufklapper (`AngebotBauen.tsx`), am Telefon wählt `Kundensuche` — beide
   zeigten die Sperre nicht. Vera baute ein Angebot an einen gesperrten
   Interessenten, ohne es zu merken. Marke und Satz stehen jetzt hier, und
   jede Kundenwahl nimmt sie von hier.

   Ein Angebot bleibt erlaubt; der Satz sagt nur, was danach passiert.
   ══════════════════════════════════════════════════════════════════ */

type Gesperrt = { gesperrt?: boolean | undefined; sperrgrund?: string | null | undefined };

/** Die Marke „gesperrt" — mit dem Grund im Titel, oder nichts. */
export function SperrMarke({ kunde }: { kunde: Gesperrt | null | undefined }) {
  const t = useT();
  if (!kunde?.gesperrt) return null;
  return (
    <span className="kw-sperrmarke" title={kunde.sperrgrund ?? undefined}>
      <Marke art="stopp">{t("kundenwahl.gesperrt")}</Marke>
    </span>
  );
}

/** Der Satz unter dem gewählten Kunden — oder nichts. */
export function SperrSatz({ kunde }: { kunde: Gesperrt | null | undefined }) {
  const t = useT();
  if (!kunde?.gesperrt) return null;
  return (
    <p className="kw-sperrsatz" role="note">
      {kunde.sperrgrund
        ? t("kundenwahl.gesperrtSatzGrund", { grund: kunde.sperrgrund })
        : t("kundenwahl.gesperrtSatz")}
    </p>
  );
}
